import {
  Calendar,
  GearSix,
  IdentificationCard,
  Lightning,
  LinkSimple,
  Receipt,
  Target,
} from "@phosphor-icons/react";
import type { TherapistProfile } from "@/types";

export type SettingsSection =
  | "overview"
  | "profile"
  | "availability"
  | "matching"
  | "emergency"
  | "billing"
  | "integrations";

export type ProfileWithMeta = TherapistProfile & {
  deactivatedAt?: string | null;
  onboardingCompletedAt?: string | null;
};

export interface ServiceSummaryResponse {
  services: Array<{ id: string; name: string; isActive: number | boolean }>;
}

export interface MatchingProfileResponse {
  isEmpty: boolean;
}

export interface EmergencySettingsResponse {
  enabled: boolean;
  price: number | null;
}

export interface GoogleStatusResponse {
  connected: boolean;
}

export const SECTIONS: Array<{
  key: SettingsSection;
  label: string;
  description: string;
  icon: typeof GearSix;
}> = [
  { key: "overview", label: "Pregled", description: "Status profila i rezervacija", icon: GearSix },
  { key: "profile", label: "Profil", description: "Javni podaci koje klijenti vide", icon: IdentificationCard },
  { key: "availability", label: "Dostupnost", description: "Radno vrijeme i pravila", icon: Calendar },
  { key: "matching", label: "Matching", description: "Kako sistem bira preporuke", icon: Target },
  { key: "emergency", label: "Hitne konsultacije", description: "Konfiguracija hitnih termina", icon: Lightning },
  { key: "billing", label: "Naplata", description: "Podaci za račune i isplate", icon: Receipt },
  // Privremeno skriveno: Google Calendar integracija (logika ostaje na mjestu)
  // { key: "integrations", label: "Integracije", description: "Povezani kalendari i alati", icon: LinkSimple },
];
